import { useCommerce } from '../account/commerce';
import './local-studio-entry.css';

/** Shown only after the backend confirms account-free local rendering. */
export function LocalStudioEntry() {
  if (useCommerce()?.status !== 'local') return null;
  return <aside className="local-studio-entry" aria-label="Local Studio">
    <span>Local testing · No account needed</span>
    <a href="/studio">Open studio</a>
    <a href="/studio?sample=landscape&task=composition">Test landscape overlay</a>
  </aside>;
}
